import styled from 'styled-components';
import { PRIMARY } from '../../styles/colors';
import { GIVONIC } from '../../styles/fonts';

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ButtonContainer = (styled.button<{ $variant?: 'underlined' }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  border-radius: 8px;
  border: none;
  text-decoration: ${props => props.$variant === 'underlined' ? 'underline' : 'none'};
  background-color: transparent;
  font-size: 13px;
  font-family: ${GIVONIC.semiBold};
  font-weight: 600;
  text-transform: uppercase;
  transition: color 0.2s ease;
  cursor: pointer;
  width: 100%;

  /* Purple text */
  color: ${PRIMARY};

  &:hover {
    color: ${PRIMARY};
    text-decoration: underline;
  }

  &:active {
    color: ${PRIMARY};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(106, 13, 173, 0.1);
  }
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
